import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import darLogo from '../images/dar-logo.png';
import lfLogo from '../images/linksfarm-logo.png';
import '../styles/Login.css';
import ActivityIndicator from '../widgets/ActivityIndicator';
import MNEAndAEView from './MNEAndAEView';
import UserAccounts from './UserAccounts';
import ProvincialOfficerView from './ProvincialOfficerView';
import RegionalOfficerView from './RegionalOfficerView';
import NationalOfficerView from './NationalOfficerView';
import NationalAdminView from './NationalAdminView';

class Login extends Component
{
	constructor(props) {
		super(props);
		this.state = {
			message: "",
			showActivityIndicator: false
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.goToUserView = this.goToUserView.bind(this);
		this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
	}

	handleSubmit = async (e) => {
		this.setState({showActivityIndicator: true});
		try {
			e.preventDefault();
			if(this.state.username == null) {
				this.setState({message: "Incorrect Username or Password", showActivityIndicator: false});
				return;
			}
			const response = await fetch('/login', {
				method: 'POST',
				headers: {
					Accept: 'applicatin/json',
					'Content-Type': 'application/json',
					'Access-Control-Allow-Origin': '*'
				},
				body: JSON.stringify({
					"username": this.state.username,
					"password": this.state.password
				})
			});
			this.setState({showActivityIndicator: false});
			if(!response.statusText) {
				throw Error(response.statusText);
			}
			const body = await response.text();
			var reply = JSON.parse(body);
			if(!reply.status.includes("SUCCESS")) {
				this.setState({message: reply.description, indicatorHeight: "0%"});
				return;
			}
			console.log(reply.results);
			const date = new Date();
			let month = String(date.getMonth()+1), day = String(date.getDate());
			month = (month.length < 2)? '0'+ month: month;
			day = (day.length < 2)? '0'+ day: day;
			sessionStorage.setItem("date-today", date.getFullYear() +'-'+ month +'-'+ day);
			sessionStorage.setItem("user", JSON.stringify(reply.results.user));
			sessionStorage.setItem("token", JSON.stringify(reply.results.token));
			this.goToUserView(reply.results.user.role_id);
		}
		catch(error) {
			console.log(error);
		}
	};

	goToUserView(roleID) {
		let element;
		switch(roleID) {
			case 1:
				element = <UserAccounts roleID={roleID} />;
			break;
			case 2:
				element = <UserAccounts roleID={roleID} />;
			break;
			case 3: case 7:
				element = <MNEAndAEView />;
			break;
			case 4:
				element = <ProvincialOfficerView />;
			break;
			case 5:
				element = <RegionalOfficerView />;
			break;
			case 6:
				element = <NationalOfficerView />;
			break;
			case 8:
				element = <NationalAdminView />;
		}
		ReactDOM.render(element, document.getElementById("app"));
	}

	handleOnKeyPress(e) {
		if (e.key === 'Enter') {this.handleSubmit(e)}
	}

	render() {
		let inputStyle;
		if(this.state.message !== "") {
			inputStyle = {border: "1px solid #B93832", color: "#B93832"};
		}
		const frmHeight = (this.state.message === "")? {height: '155px'}: {height: '190px'};
		return(<div id="login">
			<div id="login-form" style={frmHeight}>
				<div id="logos">
					<img src={darLogo} id="dar-logo" alt="DAR" />
					<img src={lfLogo} id="lf-logo" alt="LinkSFarMM" />
				</div>
				<input type="text" placeholder={"Username"} style={inputStyle}
					onChange={e => {
						const checker = /^[A-Za-z0-9@._-]+$/;
						const isValid = checker.test(e.target.value);
						if(isValid) {
							this.setState({username: e.target.value});
						}
						else {
							this.setState({username: null });
						}
					}}
				/>
				<input type="password" placeholder={"Password"} style={inputStyle}
					onChange={e => this.setState({password: e.target.value})} onKeyPress={this.handleOnKeyPress} />
				{this.state.message !== "" && <div id="login-msg"><div>{this.state.message}</div></div>}
				<button type="submit" onClick={this.handleSubmit}>LOGIN</button>
			</div>
			{/* {this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />} */}
			{/* <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} /> */}
		</div>);
	}
}

export default Login;
